import { render } from "./GlobalLink.vue?vue&type=template&id=75d3fef1"
import script from "./GlobalLink.vue?vue&type=script&lang=js"
export * from "./GlobalLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__